export default [
  {
    name: 'Tipo de Tarifário',
    hidden: false,
    filterSection: 'tariff_type',
    type: 'radio',
    filters: [
      { label: 'Todos', fieldName: 'price_list_time_cycle', value: 'all' },
      { label: 'Simples', fieldName: 'price_list_time_cycle', value: 's' },
      { label: 'Bi-horário', fieldName: 'price_list_time_cycle', value: 'b' },
      { label: 'Tri-horário', fieldName: 'price_list_time_cycle', value: 't' },
    ],
  },
  {
    name: 'Ofertas Comerciais',
    hidden: false,
    filterSection: 'comercial_offer',
    type: 'checkbox',
    filters: [
      {
        label: 'Condicionadas',
        fieldName: 'has_additional_restrictions',
        value: false,
      },
      {
        label: 'Com Fidelização',
        fieldName: 'contract_duration',
        value: false,
      },
      { label: 'Preços Indexados', fieldName: 'indexed_prices', value: false },
      {
        label: 'Tarifários Regulados',
        fieldName: 'is_regulated',
        value: false,
      },
      {
        label: 'Para Novos Clientes',
        fieldName: 'has_refunds_nc',
        value: false,
      },
      {
        label: 'Outros Reembolsos/Descontos',
        fieldName: 'has_refunds',
        value: false,
      },
      {
        label: 'Só Energia 100% renovável',
        fieldName: 'green_energy',
        value: false,
      },
    ],
  },
  {
    name: 'Tipo de Fatura',
    hidden: false,
    filterSection: 'billing',
    type: 'radio',
    removedSelectOnSelected: ['any'],
    excludeAllExceptOnSelect: ['any'],
    filters: [
      { label: 'Todos', fieldName: 'any_billing', value: false },
      { label: 'Eletrónica', fieldName: 'electronic_billing', value: false },
      { label: 'Em papel', fieldName: 'paper_billing', value: false },
    ],
  },
  {
    name: 'Método de Pagamento',
    hidden: false,
    filterSection: 'payment_method',
    type: 'radio',
    filters: [
      { label: 'Todos', fieldName: 'any_payment', value: false },
      { label: 'Débito Direto', fieldName: 'direct_debit', value: false },
      { label: 'Multibanco, Payshop, CTT', fieldName: 'atm_ctt', value: false },
    ],
  },
  {
    name: 'Comercializadores',
    hidden: false,
    filterSection: 'entities',
    type: 'checkbox',
    search: true,
    fillFromApi: true,
    filters: [],
  },
]



// WEBPACK FOOTER //
// ./src/containers/FiltersSectionV2/data.js